__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "memberPortal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "13.3.11", () => (__webpack_require__.e("node_modules_angular_common_fesm2020_http_mjs-_68760").then(() => (() => (__webpack_require__(58987))))));
			register("@angular/common", "13.3.11", () => (__webpack_require__.e("node_modules_angular_common_fesm2020_common_mjs-_ec490").then(() => (() => (__webpack_require__(94666))))));
			register("@angular/core", "13.3.11", () => (__webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs").then(() => (() => (__webpack_require__(22560))))));
			register("@angular/forms", "13.3.11", () => (__webpack_require__.e("node_modules_angular_forms_fesm2020_forms_mjs-_2e340").then(() => (() => (__webpack_require__(2508))))));
			register("@angular/router", "13.3.11", () => (__webpack_require__.e("node_modules_angular_router_fesm2020_router_mjs-_62f50").then(() => (() => (__webpack_require__(69706))))));
			register("@ckeditor/ckeditor5-angular", "2.0.2", () => (__webpack_require__.e("node_modules_ckeditor_ckeditor5-angular___ivy_ngcc___fesm2015_ckeditor-ckeditor5-angular_js-_e1811").then(() => (() => (__webpack_require__(18762))))));
			register("@ng-bootstrap/ng-bootstrap", "12.1.2", () => (__webpack_require__.e("node_modules_ng-bootstrap_ng-bootstrap_fesm2020_ng-bootstrap_mjs-_92640").then(() => (() => (__webpack_require__(73847))))));
			register("@ng-select/ng-select", "8.1.1", () => (__webpack_require__.e("node_modules_ng-select_ng-select_fesm2020_ng-select-ng-select_mjs-_69b91").then(() => (() => (__webpack_require__(32655))))));
			register("@parliament/ckeditor5-classic", "1.0.71469-rc", () => (__webpack_require__.e("node_modules_parliament_ckeditor5-classic_build_ckeditor_js").then(() => (() => (__webpack_require__(33692))))));
			register("@parliament/core", "2025.6.2", () => (__webpack_require__.e("node_modules_parliament_core_fesm2020_parliament-core_mjs-_140a1").then(() => (() => (__webpack_require__(29058))))));
			register("ngx-toastr", "14.2.1", () => (__webpack_require__.e("node_modules_ngx-toastr_fesm2020_ngx-toastr_mjs-_9f8a0").then(() => (() => (__webpack_require__(94817))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};